/* eslint-disable max-len */
import { Link } from "@quintype/components";
import { get } from "lodash";
import PropType from "prop-types";
import React from "react";
// import assetify from "@quintype/framework/assetify";
// import logo from "../../../../assets/images/newslaundry_logo.png";

import "./subscription-appeal.m.css";

const subscriptionAppeals = [
  {
    name: "ground reports",
    text:
      "This is not an ad. An ad would never fund a story like this. Would you? Pay for free, fair, robust journalism that isn’t influenced by advertisers.",
    hindiText:
      "यह एक विज्ञापन नहीं है. कोई विज्ञापन ऐसी रिपोर्ट को फंड नहीं कर सकता, लेकिन आप कर सकते हैं, क्या आप करेंगे? विज्ञापनदाताओं के दबाव में न आने वाली आज़ाद व ठोस पत्रकारिता के लिए अपना योगदान दें.",
    imageURL:
      "https://images.assettype.com/newslaundry/2022-05/7f7922fa-a1a3-474e-9349-fe65ac7b25f7/NL_Subscription_5.png"
  },
  {
    name: "podcasts",
    text:
      "Producing a quality journalism podcast is an expensive enterprise. Subscribe now to help us bring you more award-winning podcasts.",
    hindiText:
      "एक अच्छे स्तर की प्रमाणिक पॉडकास्ट बनाना, परिश्रम के साथ-साथ महंगा काम भी है. हम आपके लिए और कई अवार्ड जीतने वाली और रोचक पॉडकास्ट ला सकें, इसमें हमारा सहयोग करें. न्यूज़लॉन्ड्री को सब्सक्राइब करें.",
    imageURL:
      "https://images.assettype.com/newslaundry/2022-06/ad6a561d-1c0c-46a0-8397-0d29f861afda/show.png"
  },
  {
    name: "stories on media acquisitions",
    text:
      "Supporting independent media has never been more important. We need you to step up. For we depend on you for support, not on government or corporate advertisers.",
    hindiText:
      "स्वतंत्र मीडिया का समर्थन और सहयोग करना आज बहुत जरूरी हो गया है. हमें आपके सहयोग की जरूरत है. क्योंकि हम सरकारों या कॉरपोरेट विज्ञापन दाताओं के सहयोग पर नहीं, बल्कि आपके सहयोग पर निर्भर हैं.",
    imageURL:
      "https://images.assettype.com/newslaundry/2022-08/fb9ec400-b15f-4aee-8c58-0a15d19d147b/NL_HOMEPAGE_1_copy.png"
  },
  {
    name: "independent media",
    text:
      "The media must be free and fair, uninfluenced by corporate or state interests. That's why you, the public, need to pay to keep news free.",
    hindiText:
      "मीडिया को कॉरपोरेट या सत्ता के हितों से अप्रभावित, आजाद और निष्पक्ष होना चाहिए. इसीलिए आपको, हमारी जनता को, पत्रकारिता को आजाद रखने के लिए खर्च करने की आवश्यकता है. आज ही सब्सक्राइब करें.",
    imageURL:
      "https://images.assettype.com/newslaundry/2022-08/938f8262-4fed-42ba-a67f-e63ab4b261ec/NL_Subscription_1_copy.png"
  },
  {
    name: "so sketchy",
    text:
      "We want to revive the fading tradition of political commentary through cartoon, a medium that today more than ever needs to be rewarded and not censored. So Sketchy is a step in that direction. We want to do much more. We are counting on your support.",
    hindiText: "",
    imageURL:
      "https://images.assettype.com/newslaundry/2022-08/fb9ec400-b15f-4aee-8c58-0a15d19d147b/NL_HOMEPAGE_1_copy.png"
  }
];

const pressFreedomText = {
  heading: "Press Freedom Fund",
  hindiHeading: "प्रेस फ्रीडम फंड",
  text: (
    <div styleName="appeal-text-div">
      <span>
        Democracy isn&apos;t possible without a free press. And the press is
        unlikely to be free without reportage on the media.
      </span>
      <span>
        As India slides down democratic indicators, we have set up a Press
        Freedom Fund to examine the media&apos;s health and its challenges.
      </span>
    </div>
  ),
  hindiText: (
    <div styleName="appeal-text-div">
      <span>
        जैसे प्रेस की आजादी के बिना लोकतंत्र एक कल्पना है, वैसे ही बिना मीडिया
        पर बात किए प्रेस की आजादी। भारत जिस तरह से धीरे-धीरे लोकतांत्रिक मानकों
        पर रसातल की ओर जा रहा है।
      </span>
      <span>
        ऐसे में &apos;प्रेस फ्रीडम फंड&apos; के जरिए हमारा प्रयास है कि मीडिया
        के समक्ष चुनौतियों और उसके मौजूदा हालातों का आकलन किया जाए। हमारे इस
        प्रयास में आज ही सहयोग कीजिए। प्रेस फ्रीडम फंड में योगदान दीजिए।
      </span>
    </div>
  ),
  ctaText: "Contribute now",
  ctaHindiText: "योगदान दें",
  imageURL:
    "https://images.assettype.com/newslaundry/2022-08/fb9ec400-b15f-4aee-8c58-0a15d19d147b/NL_HOMEPAGE_1_copy.png",
  ctaURL: "/nl-sena/press-freedom-fund"
};

const SubscriptionAppealCTA = ({ element, subAppeal, isPressFreedom }) => {
  const [isHindi, setIsHindi] = React.useState();
  React.useEffect(() => {
    setIsHindi(global.location.host.includes("hindi."));
  }, []);

  const ctaTitle = get(element, ["metadata", "cta-title"], "");
  const ctaURL = get(element, ["metadata", "cta-url"], "");

  let derivedCTAURL = "";
  let selectedSubscriptionAppeal = null;

  if (ctaURL) {
    derivedCTAURL = ctaURL.split("https://www.newslaundry.com")[1];
  }

  if (subAppeal) {
    selectedSubscriptionAppeal = subscriptionAppeals.find(
      appeal => appeal.name === subAppeal
    );
  }

  const DescriptionText = () => {
    return (
      <span>
        {(selectedSubscriptionAppeal &&
          (isHindi
            ? selectedSubscriptionAppeal.hindiText
            : selectedSubscriptionAppeal.text)) ||
          ctaTitle}
      </span>
    );
  };

  return (
    <div styleName="div-container">
      <div styleName="wrapper" className="full-width">
        <div styleName="left-container">
          <img
            src={
              (selectedSubscriptionAppeal &&
                selectedSubscriptionAppeal.imageURL) ||
              "https://images.assettype.com/newslaundry/2022-08/fb9ec400-b15f-4aee-8c58-0a15d19d147b/NL_HOMEPAGE_1_copy.png"
            }
            alt="subscription-appeal-image"
            styleName="subscription-appeal-image"
          />
        </div>
        <div styleName="middle-container">
          <div styleName="row-wrapper">
            <h1 styleName="text-container">
              <span>
                {isPressFreedom
                  ? isHindi
                    ? pressFreedomText.hindiHeading
                    : pressFreedomText.heading
                  : "Support Independent Media"}
              </span>
            </h1>
          </div>
          <div styleName="appeal-wrapper">
            {isPressFreedom ? (
              isHindi ? (
                pressFreedomText.hindiText
              ) : (
                pressFreedomText.text
              )
            ) : (
              <p styleName="appeal-text">
                <DescriptionText />
              </p>
            )}
            {/* <button styleName="pay-btn"> */}
            <Link
              href={
                isPressFreedom
                  ? pressFreedomText.ctaURL
                  : derivedCTAURL ||
                    "/subscription?ref=subscription-appeal-banner"
              }
              styleName="pay-btn"
            >
              {isPressFreedom
                ? isHindi
                  ? pressFreedomText.ctaHindiText
                  : pressFreedomText.ctaText
                : "Subscribe Now"}
            </Link>
            {/* </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

SubscriptionAppealCTA.propTypes = {
  element: PropType.object,
  subAppeal: PropType.string,
  isHindi: PropType.bool,
  isPressFreedom: PropType.bool
};

export { SubscriptionAppealCTA };
